import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Title } from '@angular/platform-browser';
import { ProductService } from '../../services/product.service'
import { CartService } from '../../services/cart.service'
import { Product } from '../../entities/product.entities'

import { HeaderComponent } from '../../header/header.component';
@Component({
  selector: 'app-detail-item',
  templateUrl: './detail-item.component.html',
  styleUrls: ['./detail-item.component.css']
})
export class DetailItemComponent implements OnInit {

  id: any
  private deproduct: Product;

  constructor(private activatedRoute: ActivatedRoute, public productService: ProductService, private cartService: CartService,private titleService: Title ,public header : HeaderComponent) {


  }


  ngOnInit() {
    
    let a;
    this.activatedRoute.params.subscribe(params => {
      a = params['id'];
    })
    this.deproduct = this.productService.findProductID(a)
    this.titleService.setTitle(this.deproduct.name);
    if (this.deproduct != null) {
      sessionStorage.setItem("is_reloaded_detailItem", JSON.stringify(this.deproduct))
    }else{
      this.deproduct = JSON.parse(sessionStorage.getItem("is_reloaded_detailItem"))
    }
  }
  buttonAdd(i, id) {
    this.cartService.pushCart(id);
    alert("เพิ่มสินค้าเข้า ตระกร้า")
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-item/detail-item.component.ts